import React, { ReactNode, useState } from "react";

import Chatbox from "../Chatbox";
import { NavLink } from "react-router-dom";
import ProfileImage from "../ProfileImage";
import TimeAgo from "../TimeAgo";
import useEvent from "../../hooks/useEvent";

export interface CommentProps {
  user: {
    ID?: string;
    email?: string;
    firstname: string;
    lastname: string;
    image?: string;
  };
  time: Date;
  message: ReactNode;
  replies?: CommentProps[];
  children?: ReactNode;
  commentID?: string;
}

const Comment = ({ user, time, message, replies, children }: CommentProps) => {
  const event = useEvent();
  const [isReplying, setIsReplying] = useState(false);
  const { image, firstname, lastname, email, ID } = user || {};

  const nestedComments = (
    <>
      {replies?.map((reply, key) => {
        return (
          <Comment
            user={reply.user}
            time={reply.time}
            message={reply.message}
            replies={reply.replies}
            key={key}
          />
        );
      })}
    </>
  );

  return (
    <div className="flex mt-8">
      <div className="w-1/12 mr-4">
        <NavLink to={`/${event}/profiles/${ID}`}>
          <ProfileImage src={image} />
        </NavLink>
      </div>
      <div className="w-full">
        <div className="flex items-center justify-start">
          <div className="my-1 text-sm font-medium">
            <NavLink to={`/${event}/profiles/${ID}`}>
              {firstname && lastname
                ? `${firstname} ${lastname}`
                : email
                ? email
                : ID
                ? ID
                : "Anonymous User"}
            </NavLink>
          </div>
          <div className="ml-4">
            <div className="text-xs text-gray-400">
              <TimeAgo time={time} />
            </div>
          </div>
        </div>
        <div className="leading-loose">{message}</div>
        <div className="mt-2">
          <button
            type="button"
            className="text-sm font-medium uppercase"
            onClick={() => setIsReplying((toggle) => !toggle)}
          >
            {isReplying ? "Cancel" : "Reply"}
          </button>
        </div>

        {isReplying ? (
          <div className="max-w-sm mt-4">
            <Chatbox onNewMessage={() => setIsReplying(false)} />
          </div>
        ) : null}

        {nestedComments}
        {children}
      </div>
    </div>
  );
};

export default Comment;
